import { getMatchDateTime, getCompanyNow } from './tournamentPredictionWindows';

export const MIN_VALUE_1_FOR_REWARDS = 5;

/** Latest scheduled kickoff across tournament games (the final match). */
export function getFinalMatchDateTime(games, timezone) {
  if (!Array.isArray(games) || games.length === 0) return null;

  let latest = null;
  for (const game of games) {
    const kickoff = getMatchDateTime(game, timezone);
    if (!latest || kickoff.isAfter(latest)) {
      latest = kickoff;
    }
  }
  return latest;
}

/** True once the final match kickoff time has passed. */
export function isAfterFinalMatch(games, timezone, now = getCompanyNow(timezone)) {
  const finalKickoff = getFinalMatchDateTime(games, timezone);
  if (!finalKickoff) return false;
  return !finalKickoff.isAfter(now);
}

export function dealerMeetsMinValue1(goal, min = MIN_VALUE_1_FOR_REWARDS) {
  return Number(goal?.value_1 ?? 0) >= min;
}

/**
 * Why tournament rewards are locked, or null when unlocked.
 * @returns {'before_final' | 'min_value_1' | null}
 */
export function getTournamentRewardsLockedReason({
  isTournament,
  games,
  timezone,
  goal,
  now = getCompanyNow(timezone),
}) {
  if (!isTournament) return null;
  if (!isAfterFinalMatch(games, timezone, now)) return 'before_final';
  if (!dealerMeetsMinValue1(goal)) return 'min_value_1';
  return null;
}

export function isTournamentRewardsLocked(params) {
  return getTournamentRewardsLockedReason(params) !== null;
}
